const MINIMUM_STEPS = 1;

const calculateProgressPercentage = (currentStep, totalSteps) => {
  if (totalSteps <= MINIMUM_STEPS) return 0;
  const clampedCurrentStep = Math.max(0, Math.min(currentStep, totalSteps - 1));
  return (clampedCurrentStep / (totalSteps - 1)) * 100;
};

const StepProgressBar = ({ currentStep, totalSteps }) => {
  const progressPercentage = calculateProgressPercentage(currentStep, totalSteps);

  return (
    <div className="w-full px-4 py-2 flex items-center gap-2">
      <div className="flex-1 h-4 rounded-full bg-[#4125032b] overflow-hidden relative">
        <div
          className="h-full z-20 relative overflow-hidden bg-gradient-to-t from-[#FB155A] to-[#FFA601] transition-all duration-700 ease-in-out"
          style={{ width: `${progressPercentage}%` }}
        >
          <div className="progress-wave" />
        </div>
      </div>
    </div>
  );
};

export default StepProgressBar;